import { fillable } from 'ember-cli-page-object';

export const CONFIRM_INPUT_SELECTOR = '[data-test-modal-confirm]';

export default {
  confirm: fillable(CONFIRM_INPUT_SELECTOR),
  async confirmDelete(confirmString = 'DELETE') {
    await this.confirm(confirmString);
  },
};
